import React from 'react';
import LeadsListPage from 'modules/my-sales/submodules/leads/list/page';

const LeadsPage = () => {
  return <LeadsListPage />;
};

export default LeadsPage;
